import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import 'components/styles/successfully-linked.css';
import useSmallScreenSize from 'hooks/useSmallScreenSize';
import { ReactComponent as TickMark } from 'assets/images/tick-mark.svg';
import { ReactComponent as CloseIcon } from 'assets/images/close-icon.svg';

const SuccessfullyLinked = () => {
  const { t } = useTranslation();
  const [isHidden, setIsHidden] = useState(false);
  const isSmallScreen = useSmallScreenSize();

  const handleClose = () => {
    setIsHidden(true);
  };

  return (
    <div className="success-container">
      <div className={`success-bar ${isHidden ? 'hide' : ''}`}>
        <div className="success-description">
          <TickMark />
          <div>{t('PARTNERSHIP_PORTAL.SUCCESS_LINKED')}</div>
        </div>
        <div className="success-actions">
          {isSmallScreen ? (
            <div className={`action-text ${isHidden ? 'hide' : ''}`} onClick={handleClose}>
              Action
            </div>
          ) : (
            <CloseIcon
              className={`success-close ${isHidden ? 'hide' : ''}`}
              onClick={handleClose}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SuccessfullyLinked;
